'use client'
import React, { useState } from 'react'
import { Fragment } from 'react'
import LinkComponent from '@components/LinkComponent'
import Image from 'next/image'
import { Tab } from '@headlessui/react'
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import { AiOutlineLayout } from "react-icons/ai"
import tailwindConfig from '@tailwind.config'
import CurrencySymbol from '@components/CurrencySymbol'

const ProjectProperties = ({ properties, saleProperties, rentProperties, lang, dictionary }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <div className='sm:mt-0 mt-4'>
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className={`sm:w-1/2 w-full mb-2`}>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `border-[1px] border-maincolor text-maincolor p-1 rounded-full`
                        }
                        >
                            {dictionary.forSale} ({saleProperties})
                        </button>
                    )}
                </Tab>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-full` : `border-[1px] border-maincolor text-maincolor p-1 rounded-full`
                        }
                        >
                            {dictionary.forRent} ({rentProperties})
                        </button>
                    )}
                </Tab>
            </Tab.List>
            <Tab.Panels className='mb-2'>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'sale' || property.saleType == 'salerent') && (
                        <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
                            <div className='w-full flex flex-row items-center text-maincolor py-2'>
                                <div className='relative w-[120px] aspect-[4/3] flex-shrink-0 rounded-xl overflow-hidden'>
                                    <Image
                                        // placeholder="blur"
                                        // blurDataURL={property.blur}
                                        // className='object-fit'
                                        className='object-cover cursor-pointer hover:shadow-xl'
                                        src={property.cover}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        // alt={property.slug}
                                    />
                                </div>
                                <div className='w-full flex sm:flex-row flex-col ml-4 items-center'>
                                    <div className='flex-col sm:w-1/3 w-full flex-shrink-0 overflow-x-clip line-clamp-3'>
                                        <span className='text-third font-semibold'><CurrencySymbol lang={lang} />{property.salePrice}</span>
                                        <p className=' sm:flex hidden'>{property.name}</p>
                                    </div>
                                    <div className='flex flex-row w-full justify-between sm:ml-4 ml-0'>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                            <BiSolidBed
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.beds}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                            <BiSolidBath
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.baths}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                            <AiOutlineLayout
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.sqm}</p>
                                        </div>
                                        <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-full'>{dictionary.view}</button>
                                    </div>
                                </div>
                            </div>
                        </LinkComponent>
                    ))
                )}
                </Tab.Panel>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'rent' || property.saleType == 'salerent') && (
                        <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
                            <div className='w-full flex flex-row items-center text-maincolor py-2'>
                                <div className='relative w-[120px] aspect-[4/3] flex-shrink-0 rounded-xl overflow-hidden'>
                                    <Image
                                        // placeholder="blur"
                                        // blurDataURL={property.blur}
                                        // className='object-fit'
                                        className='object-cover cursor-pointer hover:shadow-xl'
                                        src={property.cover}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        // alt={property.slug}
                                    />
                                </div>
                                <div className='w-full flex sm:flex-row flex-col ml-4 items-center'>
                                    <div className='flex-col sm:w-1/3 w-full flex-shrink-0 overflow-x-clip line-clamp-3'>
                                        <span className='text-third font-semibold'><CurrencySymbol lang={lang} />{property.rentPrice}/{dictionary.month}</span>
                                        <p className=' sm:flex hidden'>{property.name}</p>
                                    </div>
                                    <div className='flex flex-row w-full justify-between sm:ml-4 ml-0'>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                            <BiSolidBed
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.beds}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                            <BiSolidBath
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.baths}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                            <AiOutlineLayout
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.sqm}</p>
                                        </div>
                                        <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-full'>{dictionary.view}</button>
                                    </div>
                                </div>
                            </div>
                        </LinkComponent>

                )))}
                </Tab.Panel>
            </Tab.Panels>
        </Tab.Group>
        <div>

        </div>
    </div>
  )
}

export default ProjectProperties